import { render, staticRenderFns } from "./EXProposalPolicyholder.vue?vue&type=template&id=30257468"
import script from "./EXProposalPolicyholder.vue?vue&type=script&lang=js"
export * from "./EXProposalPolicyholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports